<template lang="pug">
  tab-body(:id="`tab-${name}`" class='outline-none' :active="active" :name="name" :aria-selected="active" :ref="name" v-if="active" :background="background" :style="{ color }" data-test="tab")
    div(class='relative overflow-hidden outline-none' style='outline:none;')
      slot
</template>

<script>
import { mapState } from 'redux-vuex';
import { Tab } from '@/components/shared-components';

import select from '@/store/selectors';

export default {
  components: {
    TabBody: Tab.Body,
  },
  props: {
    name: {
      type: String,
      default: null,
    },
  },
  data: mapState({
    background: select.theme.brandDarkest,
    tabs: select.tabs,
    color: select.theme.alt,
  }),
  computed: {
    active() {
      return this.tabs[this.name];
    },
  },
};
</script>
